import React from "react"

import { Box } from "@mui/material"

import useStyles, { CalendarBoxStyles, CalendarDateStyles, CalendarMonthStyles, CalendarYearStyles } from "./styles/VisitorStyles"

/* Component for displaying a JS date object as a calendar-day card. */
function CalendarIcon({ dateObj }) {

    const dayOfMonth = dateObj.getDate()
    const month = dateObj.toLocaleString("default", { month: "short" })
    const year = dateObj.toLocaleString("default", { year: "numeric" })

    return (
        <Box sx={CalendarBoxStyles}>
            <Box sx={CalendarDateStyles}>{dayOfMonth}</Box>
            <Box sx={CalendarMonthStyles}>{month}</Box>
            <Box sx={CalendarYearStyles}>{year}</Box>
        </Box>
    )
}

export default CalendarIcon
